var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},_vm._l((_vm.arr),function(item,index){return _c('dragAndDrop',{key:index,staticClass:"contain",attrs:{"index":index}},[_vm._v(" "+_vm._s(index)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }